import { siteConfig } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20comparison%20workspace%20with%20spreadsheet%20on%20laptop%20screen%20surrounded%20by%20neatly%20arranged%20fashion%20items%20like%20sneakers%20hoodies%20and%20accessories%20on%20a%20warm%20cream%20background%20soft%20natural%20lighting%20from%20large%20window%20editorial%20lifestyle%20photography%20with%20organic%20composition%20and%20gentle%20shadows%20aesthetic%20minimal%20scandinavian%20vibe&width=1600&height=900&seq=hero-bg-2025&orientation=landscape"
        alt="GTBuy Spreadsheet product comparison workspace with fashion items"
        title="GTBuy Spreadsheet - Smart Product Comparison Tool"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-4 font-[family-name:var(--font-heading)] leading-tight">
            Compare Smarter
            <br />
            <span className="italic">Shop Better</span>
          </h1>
          <p className="text-base md:text-lg text-white/85 max-w-xl mx-auto mb-8 leading-relaxed font-[family-name:var(--font-body)] font-light">
            The GTBuy spreadsheet system helps you compare products across categories instantly.
            Save time, find the best deals, and make data-driven shopping decisions.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={siteConfig.mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer w-full sm:w-auto"
            >
              gtbuk sheet
            </a>
            <a
              href={siteConfig.mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 bg-background-50/90 text-foreground-950 font-semibold text-sm rounded-md hover:bg-background-50 transition-all duration-200 whitespace-nowrap cursor-pointer w-full sm:w-auto backdrop-blur-sm"
            >
              buy it now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}